import type { Document } from "@contentful/rich-text-types";
import { getBlockId } from "@/services/contentful/assemblies/page/adapter/utils";
import {
  UiConfigurationAdapter,
  type UiConfigurationInput,
} from "@/services/contentful/topics/UIConfiguration/ui-configuration.adapter";
import type {
  RawContentBlockBase,
  SectionTaglinePageBlock,
} from "@/types/page-block";

export type SectionTaglineInput = RawContentBlockBase & {
  __typename: "SectionTagline";
  sys?: { id: string; locale?: string };
  text?: { json?: Document };
  anchorId?: string;
  uiConfiguration?: UiConfigurationInput;
};

export function SectionTaglineAdapter(
  item: SectionTaglineInput,
  index: number
): SectionTaglinePageBlock {
  const uiConfig = item.uiConfiguration
    ? UiConfigurationAdapter(item.uiConfiguration)
    : undefined;

  return {
    sys: item.sys,
    id: getBlockId(item, index),
    __typename: item.__typename,
    internalName: item.internalName,
    text: item.text ? { ...item.text, sys: item.sys } : undefined,
    backgroundColor:
      uiConfig?.backgroundColor === "black" ||
      uiConfig?.backgroundColor === "white"
        ? uiConfig.backgroundColor
        : undefined,
    color: uiConfig?.backgroundColor === "black" ? "white" : "black",
    anchorId: item.anchorId,
    paddingTop: uiConfig?.paddingTop,
    paddingBottom: uiConfig?.paddingBottom,
  };
}
